import React from 'react';
import { Route } from 'react-router-dom';
import Traveler from '../../pages/traveler';
import Travelers from '../../pages/travelers';
import TravelerProfile from '../../pages/traveler/profile';
import TravelerTrips from '../../pages/traveler/trips';
import TravelerReviews from '../../pages/traveler/reviews';
import TravelerTickets from '../../pages/traveler/tickets';
import TravelerStats from '../../pages/traveler/stats';
import TravelerNewRequest from '../../pages/traveler/new-request';
import TravelerCreateAccount from '../../pages/traveler/create-account';

const useTravelersRoutes = () => (
  <>
    <Route path="travelers">
      <Route index element={<Travelers />} />
    </Route>
    <Route path="travelers/create-account" element={<TravelerCreateAccount />} />
    <Route path="travelers/:travelerId" element={<Traveler />}>
      <Route index element={<TravelerProfile />} handle={{ tab: '/' }} />
      <Route path="trips" element={<TravelerTrips />} handle={{ tab: '/trips' }} />
      <Route path="reviews" element={<TravelerReviews />} handle={{ tab: '/reviews' }} />
      <Route path="tickets" element={<TravelerTickets />} handle={{ tab: '/tickets' }} />
      <Route path="stats" element={<TravelerStats />} handle={{ tab: '/stats' }} />
      <Route path="new-request" element={<TravelerNewRequest />} handle={{ tab: '/new-request' }} />
    </Route>
  </>
);

export default useTravelersRoutes;
